"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const i18next_1 = __importDefault(require("i18next"));
function default_1() {
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [i18next_1.default.t('연결이 불안정해요.'), (0, jsx_runtime_1.jsx)("br", {}), i18next_1.default.t('로그아웃 후 다시 로그인해주세요.')] }));
}
exports.default = default_1;
